<template>
  <div class="section">
    <div class="section-title">
      <base-section-title title="项目信息" />
    </div>

    <div class="section-content">
      <el-form v-if="!searchId" label-width="0px" class="detail-form">
        <el-form-item label="">
          <el-button size="small" type="primary" @click="openChooseDialog()">
            {{ isAgency ? '选择委托项目' : '选择项目' }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-form v-else label-width="100px" class="detail-form" inline>
        <el-form-item label="项目名称：">
          <span>{{ entrustForm.projectName || ' - ' }}</span>
        </el-form-item>
        <el-form-item v-if="isEntrust" label="委托方：">
          <span>{{ entrustForm.purchaseCompanyName || ' - ' }}</span>
        </el-form-item>
        <el-form-item label="负责人：">
          <span>{{ entrustForm.purchaseLink || ' - ' }}</span>
          <span class="m-l-10 m-r-10">
            {{ entrustForm.linkTelephone || ' - ' }}
          </span>
          <el-button
            v-if="!readOnly"
            class="more-btn"
            type="text"
            @click="openChooseDialog()"
          >
            {{ isAgency ? '【更换委托项目】' : '【更换项目】' }}
          </el-button>
          <el-button class="more-btn" type="text" @click="openDetail">
            查看更多
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!----------项目详情弹窗----------->
    <el-dialog
      title="项目信息"
      class="dialog"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <div class="card no-padding no-margin">
        <div class="section">
          <div class="section-content">
            <el-form label-width="150px" class="detail-form">
              <el-form-item label="项目名称：">
                <span>{{ entrustForm.projectName || ' - ' }}</span>
              </el-form-item>
              <el-form-item label="项目编号：">
                <span>{{ entrustForm.projectCode || ' - ' }}</span>
              </el-form-item>
              <el-form-item label="项目概算：">
                <span>{{ strToThousands(projectBudget) }}</span>
                <span style="display: inline-block; margin-left: 0.5rem;">
                  万元
                </span>
                <money-in-cn :money="projectBudget * 10000" />
              </el-form-item>
              <el-form-item label="项目类型：">
                <span>
                  {{
                    projectTypeDict.translate(entrustForm.projectType).label ||
                      ' - '
                  }}
                </span>
              </el-form-item>
              <el-form-item
                v-if="
                  entrustForm.projectType ===
                    projectTypeDict.ASSET_DISPOSAL.value
                "
                label="处置方式："
              >
                <span>
                  {{
                    entrustForm.assetDisposalMethod
                      ? projectAssetDisposalMethodDict.translate(
                        entrustForm.assetDisposalMethod
                      ).label
                      : projectAssetDisposalMethodDict.EXPENDITURE.label
                  }}
                </span>
              </el-form-item>
              <template v-if="isRegisterProject">
                <el-form-item label="投资类型：">
                  <span>
                    {{
                      registerInvestTypeDict.translate(
                        entrustForm.investmentType
                      ).label || ' - '
                    }}
                  </span>
                </el-form-item>
                <el-form-item label="是否集中采购：">
                  <span>
                    {{
                      registerIsFocusPurchaseDict.translate(
                        entrustForm.centralizedPurchaseType
                      ).label || ' - '
                    }}
                  </span>
                </el-form-item>
              </template>
              <el-form-item label="项目地点：">
                <span>
                  {{
                    entrustForm.province
                      ? `${entrustForm.province} - ${entrustForm.city} - ${entrustForm.area}`
                      : '-'
                  }}
                </span>
              </el-form-item>
              <el-form-item
                v-if="entrustForm.country !== '中国'"
                label="详细地址："
              >
                <span>
                  {{
                    entrustForm.foreignAddress
                      ? entrustForm.foreignAddress
                      : ' - '
                  }}
                </span>
              </el-form-item>
              <el-form-item
                v-if="entrustForm.country === '中国'"
                label="详细地址："
              >
                <span>
                  {{ entrustForm.address ? entrustForm.address : ' - ' }}
                </span>
              </el-form-item>
              <el-form-item label="附件：">
                <upload
                  v-if="entrustForm.attachmentGroupId"
                  :props-data="{
                    groupIdBefore: entrustForm.attachmentGroupId,
                    disabled: true
                  }"
                />
                <span v-else>-</span>
              </el-form-item>
              <el-form-item v-if="isEntrust" label="委托方：">
                <span>{{ entrustForm.purchaseCompanyName || ' - ' }}</span>
              </el-form-item>
              <el-form-item label="负责人：">
                <span>{{ entrustForm.purchaseLink || ' - ' }}</span>
              </el-form-item>
              <el-form-item label="联系方式：">
                <span>{{ entrustForm.linkTelephone || ' - ' }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--------新增委托弹窗------------>
    <entrust-add-project-dialog
      ref="entrustAddProjectDialog"
      :is-agency="isAgency"
      @setProjectId="setProjectId"
    />
  </div>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload/index'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import EntrustAddProjectDialog from './EntrustAddProjectDialog'
import MoneyInCn from '@/components/common/MoneyInCn'

// 数据字典
import { workbenchServiceDict } from '@/dictionary/system'
import {
  projectTypeDict,
  projectAssetDisposalMethodDict
} from '@/dictionary/project/common'
import {
  registerInvestTypeDict,
  registerIsFocusPurchaseDict,
  isRegisterTypeDict
} from '@/dictionary/project/register'
import { queryOrganizationDict } from '@/dictionary/query-status'

import {
  fetchEntrustDetailApi,
  getEntrustInfoByOrderIdApi
} from '@/api/procure/entrust'
import { fetchRegisterDetailApi } from '@/api/procure/register'

import { strToThousands } from '@/utils/utils'
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'EntrustInfoDialog',

  components: {
    Upload,
    EntrustAddProjectDialog,
    BaseSectionTitle,
    MoneyInCn
  },

  model: {
    prop: 'searchId',
    event: 'update'
  },

  props: {
    searchId: {
      type: [Number, String],
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    // 委托项目信息
    entrustInfo: {
      type: Object,
      default: () => ({})
    },
    // 是否已发布
    isRelease: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialogVisible: false, // 显示弹窗

      projectInfo: {}, // 项目信息表单
      entrustForm: {}, // 委托项目信息

      projectTypeDict, // 项目类型字典
      registerInvestTypeDict,
      registerIsFocusPurchaseDict,
      projectAssetDisposalMethodDict
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    // 是否是代理机构操作
    isAgency() {
      return this.currentWorkbench === workbenchServiceDict.AGENCY.value
    },

    // 采购人是委托方，代理机构是被委托方
    searchApi() {
      if (this.currentWorkbench === workbenchServiceDict.PURCHASER.value) {
        return this.isRelease
          ? getEntrustInfoByOrderIdApi
          : fetchRegisterDetailApi
      } else if (
        this.currentWorkbench === workbenchServiceDict.AGENCY.value &&
        !this.isRelease
      ) {
        return fetchEntrustDetailApi
      } else {
        return getEntrustInfoByOrderIdApi
      }
    },

    // 项目概算
    projectBudget() {
      return this.entrustForm.projectBudget || this.entrustForm.budget || '-'
    },

    // 是否是登记项目
    isRegisterProject() {
      return this.entrustForm.isRegisterType === isRegisterTypeDict.YES.value
    },

    /**
     * 是否是委托采购
     * 非项目登记 || 项目登记且委托采购
     */
    isEntrust() {
      return (
        !this.isRegisterProject ||
        (this.isRegisterProject &&
          this.entrustForm.projectOrgMethod ===
            queryOrganizationDict.ENTRUST.value)
      )
    }
  },

  watch: {
    searchId: {
      handler: function(val) {
        if (val && val != '0' && !this.entrustInfo.projectId) {
          this.handleProjectLook()
        }
      },
      immediate: true
    },

    entrustInfo: {
      handler: function(val) {
        this.entrustForm = cloneDeep(val)
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    strToThousands,

    /**
     * 查看项目信息
     */
    handleProjectLook() {
      // 如果项目id为空，则不查看
      if (!this.searchId) {
        return
      }

      // 如果有外部传入的委托项目信息，则不调用接口
      if (this.entrustInfo.searchId) {
        return
      }

      this.searchApi(this.searchId)
        .then(res => {
          const data = res.data || {}
          const { agentInfo, entrusterInfo, ...other } = data
          this.entrustForm = {
            ...agentInfo,
            ...entrusterInfo,
            ...other
          }
          this.$emit('setEntrustInfo', this.entrustForm)
        })
        .catch(err => {
          this.setProjectId('')
          this.$message.error(err.message || '获取项目信息失败')
        })
    },

    /**
     * 查看更多
     */
    openDetail() {
      this.dialogVisible = true
    },

    /**
     * 打开选择委托项目的弹窗
     */
    openChooseDialog() {
      this.$refs.entrustAddProjectDialog.open(this.searchId)
    },

    /**
     * 得到projectId
     */
    setProjectId(data) {
      this.$emit('update', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  ::v-deep .el-dialog {
    max-width: 800px;
    min-width: 400px;
    width: 50%;
  }
}

.more-btn {
  ::v-deep &.el-button--text {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
